import { styled } from '@precis-digital/kurama/utils'
import Link from 'next/link'

export const UnstyledLink = styled(Link)(() => ({
  textDecoration: 'none',
  color: 'inherit',
  ':hover': {
    textDecoration: 'none'
  }
}))
